module.exports = __webpack_public_path__ + "img/grupo-alta.232e7d6f.png";